import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CallbackComponent} from "./callback.component";
import {AuthGuard} from "@auth0/auth0-angular";

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'services',
    loadChildren: async () =>
      (await import('./modules/booking/project.module')).ProjectModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: async () =>
      (await import('./modules/admin/admin.module')).AdminModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: async () =>
      (await import('./modules/profile/profile.module')).ProfileModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'requests',
    loadChildren: async () =>
      (await import('./modules/request/request.module')).RequestModule
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'services',
  },
  {
    path: '**',
    redirectTo: 'services'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
